var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"myTitle-tem flex align-items",class:{'text-2': _vm.type == 2}},[_c('h3',{staticClass:"flex align-items"},[_c('span',{staticClass:"icon rotate"}),_vm._v("\n        "+_vm._s(_vm.title)+"\n        "),(_vm.type == 2)?_c('dv-decoration-2',{staticStyle:{"width":"100%","height":"5px"}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }